import { render, staticRenderFns } from "./RestrictedAreaEditor.vue?vue&type=template&id=2e24c9a2&scoped=true"
import script from "./RestrictedAreaEditor.vue?vue&type=script&lang=js"
export * from "./RestrictedAreaEditor.vue?vue&type=script&lang=js"
import style0 from "./RestrictedAreaEditor.vue?vue&type=style&index=0&id=2e24c9a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e24c9a2",
  null
  
)

export default component.exports